/* istanbul ignore file */

import { css } from 'styled-components';

export const MAX_WIDTH = 400;

export const carouselWrapper = css`
  position: relative;
  width: 100%;
  margin: 0 auto;
  max-width: ${MAX_WIDTH}px;
`;
